<template>
	<div>
		<router-view></router-view>
	</div>
</template>
<script>

export default {
	name: 'page-messaging-templates',
};
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-messaging-templates.vue